import Vue from "vue";
import VueRouter from "vue-router";
import CompanyChineseForm from "../views/company/ChineseForm.vue";
import PersonalEnglishForm from "../views/personal/EnglishForm.vue";
import Mobile from "../views/PersonalMobile/index.vue";
import MobileChineseForm from "../views/PersonalMobile/ChineseForm.vue";
import MobileEnglishForm from "../views/PersonalMobile/EnglishForm.vue";
import PersonalChineseForm from "../views/personal/ChineseForm.vue";
import CompanyEnglishForm from "../views/company/EnglishForm.vue";
import CompanyMobileChineseForm from "../views/companyMobile/ChineseForm.vue";
import CompanyMobileEnglishForm from "../views/companyMobile/EnglishForm.vue";
import CustomerCorporate from "../views/company/index.vue";
import CustomerCorporateMobile from "../views/companyMobile/index.vue";

Vue.use(VueRouter);

const routes = [
  // {
  //   path:"",
  //   name:"",
  //   redirect:  to => {
  //     const { hash, params, query } = to
  //     return { name: 'CustomerCorporate' }
  //   }
  // },
  {
    path: "/customer/corporate/m/en",
    name: "CompanyMobileEnglishForm",
    component: CompanyMobileEnglishForm,
  },
  {
    path: "/customer/corporate/m/cn",
    name: "CompanyMobileChineseForm",
    component: CompanyMobileChineseForm,
  },
  {
    path: "/customer/corporate/m",
    name: "CustomerCorporateMobile",
    component: CustomerCorporateMobile,
  },
  {
    path: "/customer/corporate/en",
    name: "CompanyEnglishForm",
    component: CompanyEnglishForm,
  },
  {
    path: "/customer/personal/cn",
    name: "PersonalChineseForm",
    component: PersonalChineseForm,
  },
  {
    path: "/customer/personal/m/en",
    name: "MobileEnglishForm",
    component: MobileEnglishForm,
  },
  {
    path: "/customer/personal/m/cn",
    name: "MobileChineseForm",
    component: MobileChineseForm,
  },
  {
    path: "/customer/personal/m",
    name: "Mobile",
    component: Mobile,
  },
  {
    path: "/customer/personal/en",
    name: "PersonalEnglishForm",
    component: PersonalEnglishForm,
  },
  {
    path: "/customer/corporate/cn",
    name: "CompanyChineseForm",
    component: CompanyChineseForm,
  },
  {
    path: "/customer/corporate",
    name: "CustomerCorporate",
    component: CustomerCorporate,
  },
  {
    path: "/customer/personal",
    name: "index",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/personal/index.vue"),
  },
];

export default new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes: routes,
});